import Printer from './Printer'
import withState from './withState'

export default withState(Printer)
